import { createSlice } from '@reduxjs/toolkit';

import { GlobalWrapperState } from 'types/global-wrapper';

const initialState: GlobalWrapperState = {
  isLoading: true,
  accountKey: '',
  sessionId: '',
  language: 'en',
  locale: 'en_US',
  theme: 'light',
};

const globalWrapperSlice = createSlice({
  name: 'globalWrapper',
  initialState,
  reducers: {
    hideGlobalLoading(state) {
      state.isLoading = false;
    },
    setGlobalAccountKey(state, action) {
      state.accountKey = action.payload;
    },
    setGlobalSessionId(state, action) {
      state.sessionId = action.payload;
    },
    setGlobalLanguage(state, action) {
      state.language = action.payload;
    },
    setGlobalLocale(state, action) {
      state.locale = action.payload;
    },
    setGlobalTheme(state, action) {
      state.theme = action.payload;
    },
  },
});

export const {
  hideGlobalLoading,
  setGlobalAccountKey,
  setGlobalSessionId,
  setGlobalLanguage,
  setGlobalLocale,
  setGlobalTheme,
} = globalWrapperSlice.actions;

export default globalWrapperSlice.reducer;
